import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { MoveCrudService } from 'src/app/shared/services/move-crud.service';
import { Movement } from 'src/app/shared/interfaces/movement';
import { Unit } from 'src/app/shared/interfaces/unit';
import { UnitCrudService } from 'src/app/shared/services/unit-crud.service';
import { ContentType } from 'src/app/shared/interfaces/content-type';
import { PackagingType } from 'src/app/shared/interfaces/packaging-type';
import { ContentTypeCrudService } from 'src/app/shared/services/content-type-crud.service';
import { PackagingTypeCrudService } from 'src/app/shared/services/packaging-type-crud.service';
import { Move } from 'src/app/shared/interfaces/move';
import { WoProduct } from 'src/app/shared/interfaces/wo-product';

@Component({
  selector: 'app-movement-table',
  templateUrl: './movement-table.component.html',
  styleUrls: ['./movement-table.component.scss']
})
export class MovementTableComponent implements OnInit {

  movements: Move[];
  movement: Move;
  selectedMovements: Move[] = [];

  movementDialog: boolean = false;

  submitted: boolean = false;

  units: Unit[] = [];
  contentTypes: ContentType[] = [];
  packagingTypes: PackagingType[] = [];

  minActivityValues: number[] = [0, 1000];
  maxActivityValues: number[] = [0, 1000];

  contentTypeMap = new Map<string, ContentType>();
  packagingTypeMap = new Map<string, PackagingType>();

  dialogSelectContentKey : string = "";
  dialogSelectPackagingKey : string = "";

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  constructor(
   // private api: APIService,
    private movementService : MoveCrudService,
    // private unitService : UnitCrudService,
    private contentTypeService : ContentTypeCrudService,
    private packagingTypeService : PackagingTypeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Tables'},
      {label: 'Movement table'}
    ];

    this.movements = [];
    this.movement = { } as Move ;
    //this.getAllRecords();
  }

  ngOnInit(): void {
    
    this.dataState();
    let s = this.movementService.getMovementsList(); 
    s.snapshotChanges().subscribe(data => {
      this.movements = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.movements.push(jsonItem as Move);
        }
      })
    });

    // let u = this.unitService.GetUnitsList(); 
    // u.snapshotChanges().subscribe(data => {
    //   this.units = [];
    //   data.forEach(item => {
    //     let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
    //     if (jsonItem) {
    //       if (jsonItem) {
    //         jsonItem['$key'] = item.key;
    //       }
    //       this.units.push(jsonItem as unknown as Unit);
    //     }
    //   })
    // });

    let ct = this.contentTypeService.GetContentTypesList(); 
    ct.snapshotChanges().subscribe(data => {
      this.contentTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.contentTypes.push(jsonItem as unknown as ContentType);
          const content = jsonItem as unknown as ContentType;
          this.contentTypeMap.set( content.$key , content );
        }
      })
    });

    let pt = this.packagingTypeService.GetPackagingTypesList(); 
    pt.snapshotChanges().subscribe(data => {
      this.packagingTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.packagingTypes.push(jsonItem as unknown as PackagingType);
          const packaging = jsonItem as unknown as PackagingType;
          this.packagingTypeMap.set( packaging.$key , packaging );
        }
      })
    });

    // column management
    this.cols = [
      { field: 'datetime', header: 'Date Time' },
      { field: 'user', header: 'User' },
      { field: 'products', header: 'Products' },
      { field: 'fromLocation', header: 'From (location)' },
      // { field: 'fromRow', header: 'From (row)' },
      // { field: 'fromColumn', header: 'From (column)' },
      // { field: 'fromLevel', header: 'From (level)' },
      { field: 'toLocation', header: 'To (location)' },
      // { field: 'toRow', header: 'To (row)' },
      // { field: 'toColumn', header: 'To (column)' },
      // { field: 'toLevel', header: 'To (level)' },
      // { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;

    // Exports
    this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
  }

  dataState() {     
    this.movementService.getMovementsList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.Movements);
            doc.save('content-types.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.movements);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "content-types");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    //this.exportService.exportToCsv(this.movements, 'Movements', ['companyId', 'companyName', '$key', 'actions']);
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedMovements, 'content-types', exportCols);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.movement = {} as Move;
    this.submitted = false;
    this.movementDialog = true;
    this.dialogSelectContentKey = "";
    this.dialogSelectPackagingKey = "";
  }

  deleteSelectedMovements() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected Packaging Types?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.movements = this.movements.filter(val => !this.selectedMovements.includes(val));
          this.movements.forEach( pallet => {
            this.movementService.deleteMovement(pallet.$key);
          } );
          
          this.selectedMovements = [];
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging types deleted', life: 3000});
      }
  });
  }

  editMovement(movement: Move) {
    this.movement = {...movement};
    this.movementDialog = true;
  }

  deleteMovement(movement: Move) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + movement.when + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.movements = this.movements.filter(val => val.$key !== movement.$key);
            this.movement = {} as Move;
            this.movementService.deleteMovement(movement.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Movement Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.movementDialog = false;
    this.submitted = false;
  }

  saveMovement() {
    this.submitted = true;
    if (this.movement.$key) {
      this.movements[this.findIndexById(this.movement.$key)] = this.movement;                
      this.movementService.updateMovement(this.movement);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging Type Updated', life: 3000});
    } else {
      // this.pallet.id = this.createId();
      // this.pallet.image = 'product-placeholder.svg';

      if ( this.packagingTypeMap.has( this.dialogSelectPackagingKey ) ) {
        const packaging = this.packagingTypeMap.get( this.dialogSelectPackagingKey );
        // if (packaging) {
        //   this.movement.container = packaging ;
        //   if (this.movement.container.$key) {
        //     delete this.movement.container.$key
        //     delete this.movement.container.isEnabled
        //   }
        // }
      }

      if ( this.contentTypeMap.has( this.dialogSelectContentKey ) ) {
        const content = this.contentTypeMap.get( this.dialogSelectContentKey );
        // if (content) {
        //   this.movement.content = content;
        //   if (this.movement.content.$key) {
        //     delete this.movement.content.$key
        //     delete this.movement.content.isEnabled
        //   }
        // }
      }
      
      
      // dialogSelectContentKey = "";
      //  = "";)

      this.movementService.addMovement(this.movement);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Product Type Created', life: 3000});
      this.movements = [...this.movements];
    }
    this.movementDialog = false;
    this.movement = { } as Move;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.movements.length; i++) {
        if (this.movements[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeMovement(movement : Movement) {
    const movementTmp = {
      ...movement
    };
    console.log("SAVE", movementTmp);
    this.movementService.updateMovement(  movementTmp );
  }

  fromLocations(move : Move) {
    console.log(move.fromWhat);
    if (!move.fromWhat) {
      return [];
    }
    const previousProducts : WoProduct[] = Object.values(move.fromWhat);
    return previousProducts;
  }

  toLocations(move : Move) {
    console.log(move.toWhat);
    if (!move.toWhat) {
      return [];
    }
    const previousProducts : WoProduct[] = Object.values(move.toWhat);
    return previousProducts;
  }

}
